import { axios } from 'lib/axios';
import { useQnaMutation } from './useQnaMutation';

const deleteNotification = (resource, id, notificationId) =>
  axios.delete(`/api/${resource}/${id}/qna/notifications/${notificationId}`);

export const useDeleteNotification = (resource, id, onSuccess) =>
  useQnaMutation(
    resource,
    id,
    (notificationId) => deleteNotification(resource, id, notificationId),
    {
      successMessage: 'Draft notification deleted',
      onSuccess,
    }
  );
